import ArticleLayout from '@/components/feature/ArticleLayout';
import articleContents from '@/mocks/article-content';

export default function ArticleVs() {
  return <ArticleLayout article={articleContents['itaobuy-vs-alternative']} />;
}